import {
    useMutation,
    useQueryClient,
    UseMutationResult,
} from '@tanstack/react-query'
import { addAttribute } from '../../../../services/dtServices'
import { IAttribute } from '../../interfaces'

export const useCreateAttribute = (
    orgId: string,
    entityId: string,
): UseMutationResult<
    Awaited<ReturnType<typeof addAttribute>>,
    Error,
    IAttribute
> => {
    const queryClient = useQueryClient()
    return useMutation({
        mutationFn: (attribute: IAttribute) => {
            return addAttribute(orgId, entityId, {
                ...attribute,
                isSearchable: true,
            })
        },
        //client side optimistic update
        onMutate: (newAttribute: IAttribute) => {
            queryClient.setQueryData(
                ['attributes', entityId, orgId],
                (prevAttributes: IAttribute[]) => {
                    return [
                        ...prevAttributes,
                        {
                            ...newAttribute,
                            id: (Math.random() + 1).toString(36).substring(7),
                        },
                    ] as IAttribute[]
                },
            )
        },
        onSettled: () =>
            queryClient.invalidateQueries({
                queryKey: ['attributes', entityId, orgId],
            }),
    })
}
